__turbopack_context__.v({
  "ProductImageCardList--NoMargin": "sVgLMG_ProductImageCardList--NoMargin",
  "ProductImageCardList__Container": "sVgLMG_ProductImageCardList__Container",
  "ProductImageCardList__Item": "sVgLMG_ProductImageCardList__Item",
  "ProductImageCardList__Link--Desktop": "sVgLMG_ProductImageCardList__Link--Desktop",
  "ProductImageCardList__Link--Mobile": "sVgLMG_ProductImageCardList__Link--Mobile",
  "ProductImageCardList__List": "sVgLMG_ProductImageCardList__List",
  "ProductImageCardList__Row": "sVgLMG_ProductImageCardList__Row",
  "ProductImageCardList__Title": "sVgLMG_ProductImageCardList__Title",
});
